import { MediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { MetaPages } from '../../enums/pages';
import Tabs from '../../components/molecules/tabs/tabs';
import TimePeriod from '../../components/atoms/time-period/time-period';
import TimePeriodMobile from '../../components/atoms/time-period-mobile/time-period-mobile';
import {
  getAboutBannerContent,
  getAboutBrandHeritageContent
} from '../../services/about';
import { BrandHeritageContentType, ContentType } from '../../types/content';
import { aboutRoutes } from '../../config/routes/pages';
import HeaderContainer from '../../components/molecules/header-container/header-container';
import { brandHeritageYears } from '../../constants/about';
import TabTitle from '../../components/atoms/tab-title/tab-title';

type IndexProps = {
  aboutBannerContent: ContentType;
  aboutBrandHeritageContent: BrandHeritageContentType[];
};

export function Index(props: IndexProps) {
  const { aboutBannerContent, aboutBrandHeritageContent } = props;

  const isTablet = useMediaQuery(MediaQuery.MD);

  const timeLine = aboutBrandHeritageContent.map((aboutBrandHeritageItem) => {
    const timePeriod = isTablet ? (
      <TimePeriodMobile
        key={aboutBrandHeritageItem.timePeriod}
        {...aboutBrandHeritageItem}
      />
    ) : (
      <TimePeriod
        key={aboutBrandHeritageItem.timePeriod}
        {...aboutBrandHeritageItem}
      />
    );
    return timePeriod;
  });

  const years = brandHeritageYears.map((year) => (
    <a
      className="h-full px-2 flex items-center hover:bg-hoverHeaderBackground"
      key={year}
      href={`#${year}`}
    >
      {year}
    </a>
  ));

  return (
    <>
      <TabTitle page={MetaPages.ABOUT_HERITAGE} />
      <HeaderContainer {...aboutBannerContent} />
      <Tabs tabItems={aboutRoutes} />
      <div className="w-full bg-headerBackground hidden lg:flex h-16 mt-10">
        <div className="max-w-defaultMax h-full flex justify-center items-center m-auto font-MuseoSans100 text-header6 font-extralight">
          {years}
        </div>
      </div>
      <div className="relative">
        <div className="flex flex-col my-8 timeline-container">{timeLine}</div>
      </div>
    </>
  );
}

export default Index;

export async function getStaticProps() {
  const aboutBannerContent = await getAboutBannerContent();
  const aboutBrandHeritageContent = await getAboutBrandHeritageContent();

  return {
    props: {
      aboutBannerContent,
      aboutBrandHeritageContent
    }
  };
}
